import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { ApplicantPqqSectionsComponent } from '../applicant-pqq-sections.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { DateFormatService } from '@/app/services/date-format.service';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatExpansionModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
    MatDatepickerModule,
  ],
  selector: 'app-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.css'],
})
export class DeclarationComponent implements OnInit, OnChanges {
  @Input() applicantData: any;
  @Input() isEdit: boolean;
  formGroup: FormGroup;
  @Input() isFetchApplicantData: boolean;

  constructor(
    private fb: FormBuilder,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private ApplicantPqqSectionsComponent: ApplicantPqqSectionsComponent,
    private tenderingService: TenderingService,
    private DateFormatService: DateFormatService
  ) {}

  @Output() closeModalEvent = new EventEmitter<boolean>(); // EventEmitter to notify parent
  closeModal = true;

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      // Declaration
      authorized_signatory_name: [''],
      authorized_signatory_position: [''],
      authorized_signatory_signature_date: [new Date()],
      authorized_signatory_signature: [''],
      disclaimer_accepted: [0],
    });

    // Populate form with applicantData if isEdit is true and applicantData exists
    if (this.isEdit) {
      this.patchFormValues();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isFetchApplicantData'] &&
      !changes['isFetchApplicantData'].firstChange
    ) {
      this.patchFormValues();
    }
  }
  patchFormValues() {
    this.formGroup.patchValue({
      authorized_signatory_name:
        this.applicantData?.authorized_signatory_name || '',
      authorized_signatory_position:
        this.applicantData?.authorized_signatory_position || '',
      authorized_signatory_signature_date: this.applicantData
        ?.authorized_signatory_signature_date
        ? new Date(this.applicantData.authorized_signatory_signature_date)
        : new Date(),
      authorized_signatory_signature:
        this.applicantData?.authorized_signatory_signature || '',
      disclaimer_accepted: this.applicantData?.disclaimer_accepted || 0,
    });
  }

  disclaimerAccepted(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked; // Check if the checkbox is checked
    this.formGroup.get('disclaimer_accepted')?.setValue(checked ? 1 : 0); // Update the form control
  }

  handleBack() {
    this.ApplicantPqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    const dataToSubmit = new FormData();

    // Dynamically append all form controls to FormData
    Object.keys(this.formGroup.controls).forEach((key) => {
      const value = this.formGroup.get(key)?.value;
      if (value !== null && value !== undefined && value !== '') {
        dataToSubmit.append(key, value);
      }
    });

    return dataToSubmit;
  }

  onSubmit(): void {
    if (this.formGroup.get('disclaimer_accepted').value === 0) {
      this.toast.warning(
        'Please acknowledge and accept the disclaimer ',
        'WARNING'
      );
      return;
    }
    if (this.formGroup.valid) {
      const dataToSubmit = this.prepareDataToSubmit();
      this.projectsService.projectPQQResponseStep9(dataToSubmit).subscribe({
        next: () => {
          const pqqId = this.tenderingService.getPqqId();
          this.toast.success('Pre Qualification submitted', 'SUCCESS');
          this.closeModalEvent.emit(this.closeModal);
          this.router.navigate([
            '/applicant-individual-pqq-submit-view',
            pqqId,
          ]);
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    } else {
      this.toast.warning('Please fill the required fields', 'WARNING');
      this.formGroup.markAllAsTouched();
    }
  }
}
